import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { TabsFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import UniqueId from '../../../services/uid/UniqueId';
import { AppState } from '../../../store/reducers/root';
import { getTabsControlChildrenProps } from '../../../store/selectors/form';

import TabsControl from './FormTabsControl';

interface Props {
  control: TabsFormControlViewModel;
  formId: UniqueId;
}

const mapStateToProps = (state: AppState, { formId, control }: Props) => ({
  childAuxProps: getTabsControlChildrenProps(state, formId, control.name),
  control,
  formId,
});

const connector = connect(mapStateToProps);

export type TTabsControlConnectorProps = ConnectedProps<typeof connector>;

export default connector(TabsControl);
